import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { useStore } from '../../store';
import { t } from '../../lib/i18n';
import toast from 'react-hot-toast';

const REASONS = [
  'Fraud / Scam', 'Harassment', 'No-show', 'Illegal activity',
  'Fake profile', 'Spam', 'Other',
];

interface ReportModalProps {
  open: boolean;
  onClose: () => void;
  targetId: string | null;
  targetName?: string;
}

export const ReportModal: React.FC<ReportModalProps> = ({ open, onClose, targetId, targetName }) => {
  const { reportUser, lang } = useStore();
  const [reason, setReason] = useState(REASONS[0]);
  const [details, setDetails] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!targetId) return;
    setLoading(true);
    const result = reportUser(targetId, reason, details);
    setLoading(false);
    if (result === 'err_self_report' || result === 'err_already_reported' || result === 'err_not_auth') {
      toast.error(t(lang, result));
      return;
    }
    if (result === 'blocked') toast.success(t(lang, 'toast_blocked'));
    else toast.success(t(lang, 'toast_reported'));
    setDetails('');
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} title={t(lang, 'report_title')} maxWidth="400px">
      {targetName && <p className="report-target">Reporting: <strong>{targetName}</strong></p>}
      <form onSubmit={handleSubmit} className="auth-form" noValidate>
        <div className="form-group">
          <label className="form-label">{t(lang, 'report_reason')}</label>
          <select className="form-input" value={reason} onChange={e => setReason(e.target.value)}>
            {REASONS.map(r => <option key={r}>{r}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">{t(lang, 'report_details')}</label>
          <textarea className="form-input" rows={4} value={details}
            onChange={e => setDetails(e.target.value)}
            placeholder="Describe what happened..." maxLength={1000} />
        </div>
        <button className="btn btn-danger btn-full" type="submit" disabled={loading}>
          ⚠️ {t(lang, 'report_submit')}
        </button>
      </form>
    </Modal>
  );
};
